import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../api/apiService";
import { Spinner } from "react-bootstrap";

function PrintEmployee() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const company = localStorage.getItem("company");

    const [employeeData, setEmployeeData] = useState(null);
    const [image, setImage] = useState(null)
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/employees/${id}`);
                setEmployeeData(response.data);
                setImage(`${process.env.REACT_APP_API_BASE_URL}/uploads/${response.data?.profile_picture}` || null);
                setIsLoading(false);
                setTimeout(() => {
                    window.print();
                    window.addEventListener("afterprint", handleAfterPrint);
                }, 1000);
            } catch (error) {
                setIsLoading(false);
                toast.error("Failed to fetch job data");
            }
        };

        fetchData();
        return () => {
            window.removeEventListener("afterprint", handleAfterPrint);
        };
    }, []);

    const handleAfterPrint = () => {
        window.close();
    };

    const defaultTerms = `The employee agrees to adhere to the company's policies and procedures at all times. 
    Confidentiality must be maintained regarding all company data, operations, and intellectual property. 
    Any breach of company rules may result in disciplinary action, up to and including termination of employment. 
    The company reserves the right to amend these terms with prior notice. 
    Working hours, leave entitlements, and other benefits will be governed by the company's HR policies as outlined in the employee handbook. 
    The employee must promptly inform the company of any changes in personal details, such as contact information or emergency contacts.`;

    return (
        <>
            <main className="main m-5">
                <section className="section">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold mb-0">Employee Details</h5>
                                    {isLoading ? (
                                        <div className="text-center mt-3">
                                            <Spinner animation="border" variant="primary" />
                                            <span className="ms-2">Loading...</span>
                                        </div>
                                    ) : employeeData ? (
                                        <form>
                                            <div className="row g-0">
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">First Name</h6>
                                                    <p className="text-muted">{employeeData.first_name || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Last Name</h6>
                                                    <p className="text-muted">{employeeData.last_name || "N/A"}</p>
                                                </div>
                                            </div>
                                            <div className="row g-0">
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Username</h6>
                                                    <p className="text-muted">{employeeData.username || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Employee Email</h6>
                                                    <p className="text-muted">{employeeData.email || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Employee Contact</h6>
                                                    <p className="text-muted">{employeeData.phone_number || "N/A"}</p>
                                                </div>
                                            </div>
                                            <div className="row g-0">
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Department</h6>
                                                    <p className="text-muted">{employeeData.department.department_name || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Designation</h6>
                                                    <p className="text-muted">{employeeData.role.role_name || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Monthly Salary</h6>
                                                    <p className="text-muted">{employeeData.monthly_salary || "N/A"}</p>
                                                </div>
                                            </div>
                                            <div className="row g-0">
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Fingerprint Id</h6>
                                                    <p className="text-muted">{employeeData.fingerprint_id || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Employee Status</h6>
                                                    <p className="text-muted text-cepitalize">{employeeData.status || "N/A"}</p>
                                                </div>
                                                <div className="col-sm-4">
                                                    <h6 className="fw-bold mb-0">Employee Shift</h6>
                                                    <p className="text-muted">{employeeData.shift.shift_name || "N/A"}</p>
                                                </div>
                                            </div>

                                            <div className="mt-4 mb-5 pb-5">
                                                <h5 className="fw-bold">Terms & Conditions</h5>
                                                <p className="text-justify pb-5">{defaultTerms}</p>
                                            </div>
                                            <div className="mt-4 pt-5 row g-0">
                                                <div className="col-sm-6 d-flex flex-column align-items-center">
                                                    <div className="w-75 border-dark border-bottom"></div>
                                                    <p className="text-center mt-2">Employee Signature</p>
                                                </div>

                                                <div className="col-sm-6 d-flex flex-column align-items-center">
                                                    <div className="w-75 border-dark border-bottom"></div>
                                                    <p className="text-center mt-2">Manager Signature</p>
                                                </div>
                                            </div>
                                        </form>
                                    ) : (
                                        <p>No employee data available.</p>
                                    )}
                                    {!isLoading && <h5 className="mt-5">{company}</h5>}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default PrintEmployee